import React, { Component } from 'react';
class getCRubros extends Component {

  mostrarRubros = () => {
    const rubros = this.props.rubros;
    if(rubros.length === 0) return null;
    return (
      <React.Fragment>
        {rubros.map((rubro,index) => (
          <button key={index} className="boton_rubros"
          onClick={ () => this.props.getItems(rubro.id_rubro)}>{rubro.rubro}</button>
        )) }
      </React.Fragment>
    )
  }

  render() {
    const rubros = this.props.rubros
    let data
    if(rubros.length===0){
      data =<div className="div_lbl_loading"><img alt="Cargando Imagen . . ."
            className="lbl_loading" src={ require('../image/loading.gif') } />
            </div>
    }else{
      data =<React.Fragment>
            {this.mostrarRubros()}
            </React.Fragment>
    }
    return (
      <React.Fragment>
      {data}
      </React.Fragment>
    )

  }

}

export default getCRubros;
